const constants = {
    ma: 'master_admin',
    admin: 'admin',
    sourcing: 'sourcing',
    store: 'store',
    lineManager: 'line_manager',
    focalPoint: 'focal_point',
    approver: 'approver',
    requestor: 'requestor',
    accounts: 'accounts'
}

export default constants;